import React, { FC } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { ClaimAdditionalAccountModal } from '@blocs.auth';
import { useTranslation, Trans } from '@blocs.i18n';
import UncontrolledDropdown from '@minecraft.uncontrolled-dropdown';
import DropdownToggle from '@minecraft.dropdown-toggle';
import DropdownMenu from '@minecraft.dropdown-menu';
import { useModal } from '@minecraft.modal';
import SCREEN_NAMES from '@consumer-talent.config/constants/screenNames';
import {
  MainDropDownMenuItemMobile,
  MenuItemMobile,
  RightIcon,
} from '@consumer-talent.components/core/NavLoggedIn/Styles';
import routeHelper from '@consumer-talent.utils/routeHelper';
import { FEATURE_FLAGS, useFeatureExperiment } from '@blocs.features-experiments';
import { useArtistContext } from '../ArtistContext';

interface MobileMenuWithCurrentArtistProps {
  accountSettingsLink: string;
  notificationLink: { to: string };
}

const MobileMenuWithCurrentArtist: FC<MobileMenuWithCurrentArtistProps> = ({
  notificationLink,
  accountSettingsLink,
}) => {
  const { t } = useTranslation();
  const { isArtistLocked } = useArtistContext();
  const { isOpen, open, close } = useModal();
  const isLegacyUserOnboardingDeprecated = useFeatureExperiment(FEATURE_FLAGS.WEB_ONBOARDING_DEPRECATION);

  return (
    <>
      <UncontrolledDropdown nav inNavbar direction="down">
        <DropdownToggle nav>
          <MainDropDownMenuItemMobile data-qa-id={`${SCREEN_NAMES.NAVIGATION_LINK}-account-settings`}>
            <Trans
              i18nKey="common:accountSettingsMenu.accountSettings"
              components={[<RightIcon name="caret-right" color="black" />]}
            />
          </MainDropDownMenuItemMobile>
        </DropdownToggle>
        <DropdownMenu>
          <MenuItemMobile>
            <Link data-qa-id={`${SCREEN_NAMES.NAVIGATION_LINK}-account-details`} to={accountSettingsLink}>
              {t('common:title.accountDetails')}
            </Link>
          </MenuItemMobile>
          {!isArtistLocked && (
            <MenuItemMobile component="span">
              <NavLink
                {...notificationLink}
                data-qa-id={`${SCREEN_NAMES.NAVIGATION_LINK}-notification-settings`}
                role="button"
              >
                {t('common:accountSettingsMenu.notificationSettings')}
              </NavLink>
            </MenuItemMobile>
          )}
          <MenuItemMobile>
            <NavLink
              {...routeHelper.membershipOverview.forLink()}
              data-qa-id={`${SCREEN_NAMES.NAVIGATION_LINK}-membership-billing`}
            >
              {t('common:accountSettingsMenu.membershipAndBilling')}
            </NavLink>
          </MenuItemMobile>
          {!isArtistLocked && (
            <MenuItemMobile>
              <NavLink
                {...routeHelper.profileSettingsTalents.forLink()}
                data-qa-id={`${SCREEN_NAMES.NAVIGATION_LINK}-profile-settings`}
              >
                {t('common:accountSettingsMenu.profileSettings')}
              </NavLink>
            </MenuItemMobile>
          )}
        </DropdownMenu>
      </UncontrolledDropdown>
      {!isArtistLocked && (
        <MenuItemMobile component="span">
          <NavLink
            {...routeHelper.talentDisambiguation.forLink()}
            data-qa-id={`${SCREEN_NAMES.NAVIGATION_LINK}-manage-talent`}
          >
            {t('common:accountSettingsMenu.manageTalent')}
          </NavLink>
        </MenuItemMobile>
      )}
      {!isArtistLocked && !isLegacyUserOnboardingDeprecated && (
        <MenuItemMobile component="span">
          <MenuItemMobile data-qa-id={`${SCREEN_NAMES.NAVIGATION_LINK}-additional-account-claim`} onClick={open}>
            {t('common:accountSettingsMenu.claimAdditionalAccounts')}
          </MenuItemMobile>
        </MenuItemMobile>
      )}
      <ClaimAdditionalAccountModal isOpen={isOpen} close={close} />
    </>
  );
};

export default MobileMenuWithCurrentArtist;
